import { render, staticRenderFns } from "./downloadHistory.vue?vue&type=template&id=368238e7&scoped=true"
import script from "./downloadHistory.vue?vue&type=script&lang=js"
export * from "./downloadHistory.vue?vue&type=script&lang=js"
import style0 from "./downloadHistory.vue?vue&type=style&index=0&id=368238e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368238e7",
  null
  
)

export default component.exports